import { forwardRef } from 'react';
import { Section } from './Section';
import type { SectionProps } from './Section';

export const Card = forwardRef<HTMLElement, SectionProps>(function Card({ className, ...props }, ref) {
  return <Section {...props} ref={ref} className={`card ui-card ${className ?? ''}`} />;
});
